// https://reactjs.org/docs/hooks-faq.html#is-it-safe-to-omit-functions-from-the-list-of-dependencies
// https://stackoverflow.com/questions/58624200/react-hook-useeffect-has-a-missing-dependency-dispatch
import React, { useEffect, useState } from 'react';
import {
	useLocation,
	useNavigate,
	Routes,
	Route,
	NavLink
} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { errorCatch, LanguageContext, MetaContext, POST, QueryDetail, READWITH, TranslateContext, useAuth, UserConfigContext, UserContext, ycStorage } from 'fennec-ui';
import { Layout, Avatar, Tooltip, Menu, Badge, Divider, Dropdown, Modal, Image } from 'antd';
import {
	UserOutlined,
	LogoutOutlined
} from '@ant-design/icons';

import './index.css';
import 'rc-banner-anim/assets/index.css';
import Icofont from 'react-icofont';
import CommonProfile from '../../../desktop/pages/CommonProfile';

import { HasRole } from 'fennec-ui';
import Admin from '../Admin';
import { t, translate, ycBucket } from '../../../components/Tool';
import FedHeader from '../FedHeader';
import { LangSwitchContext, TranslatesContext, useLayoutWidthContext } from '../../../components/Context';
import LangSwitch from '../../../components/LangSwitch';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import ConfigPage from '../ConfigPage';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
var _ = require('lodash');
dayjs.locale('ru');

const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;
const { confirm } = Modal;


const compare = (a, b) => {
	return a.replace(" ", "").toLowerCase() === b.replace(" ", "").toLowerCase();
};
const statusForPage = (status, element, onlyNew) => {
	var deep = 1;
	var o = element;
	while (o && o.parent) {
		deep++
		o = o.parent;
	}
	return status.filter((s) => {
		if (onlyNew && s.tipNovayaInfa === false) return false;
		switch (deep) {
			case 1:
				if (element && compare(s.tipMestonakhozhdenieMenyu, element.name)) {
					return true;
				}
				break;
			case 2:
				if (element.parent && compare(s.tipMestonakhozhdenieMenyu, element.parent.name) &&
					element && compare(s.tipMestonakhozhdeniePodMenyu, element.name)) {
					return true;
				}
				break;
			case 3:
				if (element.parent.parent && compare(s.tipMestonakhozhdenieMenyu, element.parent.parent.name) &&
					element.parent && compare(s.tipMestonakhozhdeniePodMenyu, element.parent.name) &&
					element && compare(s.tipMestonakhozhdenieZakladka, element.name)) {
					return true;
				}
				break;
			default:
				return false;
		}
		return false;
	})
};
const notifyForPage = (notify, element, onlyNew) => {
	var deep = 1;
	var o = element;
	while (o && o.parent) {
		deep++
		o = o.parent;
	}
	return notify.filter((s) => {
		if (onlyNew && s.prochitano === true) return false;
		switch (deep) {
			case 1:
				if (element && compare(s.mestonakhozhdenieMenyu, element.name)) {
					return true;
				}
				break;
			case 2:
				if (element.parent && compare(s.mestonakhozhdenieMenyu, element.parent.name) &&
					element && compare(s.mestonakhozhdeniePodMenyu, element.name)) {
					return true;
				}
				break;
			case 3:
				if (element.parent.parent && compare(s.mestonakhozhdenieMenyu, element.parent.parent.name) &&
					element.parent && compare(s.mestonakhozhdeniePodMenyu, element.parent.name) &&
					element && compare(s.mestonakhozhdenieZakladka, element.name)) {
					return true;
				}
				break;
			default:
				return false;
		}
		return false;
	})
};
const menu = (status, notify, role_by_id) => {
	const badge = (element) => {
		var stat = statusForPage(status, element, true);
		var noty = notifyForPage(notify, element, true);
		return {
			count: stat.length + noty.length
		}
	};
	const repack = (menu, role_by_id, parent) => {
		var arr = [];
		for (let i = 0; i < menu.length; i++) {
			const element = menu[i];
			if (element.func) {
				var es = element.func(element, role_by_id);
				if (element.title) {
					var o = {
						uuid: element.uuid,
						path: element.path,
						title: element.title,
						role: element.role,
						group: es.map(e => {
							if (e.menu) {
								e.menu = repack(e.menu, role_by_id);
							}
							e.role = element.role;
							return e
						}),
						badge: badge,
						parent: parent
					};
					if (o.menu) {
						o.menu = repack(o.menu, role_by_id, element);
					}
					arr.push(o);
				} else {
					es.forEach(e => {
						if (e.menu) {
							e.menu = repack(e.menu, role_by_id, element);
						}
						e.role = element.role;
						e.badge = badge;
						e.parent = parent;
						arr.push(e);
					});
				}
			} else {
				if (element.menu) {
					element.menu = repack(element.menu, role_by_id, element);
				}
				element.badge = badge;
				element.parent = parent;
				arr.push(element);
			}
		}
		return arr;
	}
	const x = [
		{
			uuid: "common",
			default: true,
			name: "Общее",
			menu: [
				{
					uuid: "profile",
					default: true,
					name: "Профиль",
					icon: function () {
						return (<UserOutlined />)
					}
				}
			]
		}
	]
	var m = repack(x, role_by_id);
	return m
};
function MenuLevelOne({ active, menu, onChange }) {
	if (menu.length <= 0) return (<></>);
	const elements = menu.map((element, index) => {
		const key = element.uuid || element.key || index;
		const icon = (element.icon) ? element.icon(element) : <></>;
		if (element.badge && element.badge(element).count > 0) {
			return (
				<Menu.Item key={key}>
					<Badge dot={true} offset={[5, 0]}>
						{icon}{element.name}
					</Badge>
				</Menu.Item>
			)
		}
		return (<Menu.Item key={key}>{element.name}</Menu.Item>)
	})
	const change = ({ key }) => {
		onChange(key, menu);
	}
	return (
		<Menu theme="light" mode="horizontal" style={{ float: 'left' }} onClick={change}
			defaultSelectedKeys={[active]}
			selectedKeys={[active]}>
			{elements}
		</Menu>
	)
}
function MenuLevelTwo({ active, menu, onChange }) {
	if (menu.length <= 0) return (<></>);
	const style = {
		marginBottom: "0px",
		marginTop: "0px",
		fontSize: "13px",
		paddingRight: "10px"
	}
	const l = (element, key) => {
		const count = (element.badge) ? element.badge(element).count : 0;
		const icon = (element.icon) ? element.icon(element) : <></>;
		return (
			<Menu.Item style={style} key={key}>
				<Tooltip title={element.name} mouseEnterDelay={0.8}>
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
							{icon}{element.name}
						</div>
						<div style={{ width: "37px", textAlign: "right" }}>
							{count > 0 && <Badge color="#ff4d4f" />}
							{/* <Badge count={count} overflowCount={99} /> */}
						</div>
					</div>
				</Tooltip>
			</Menu.Item>
		)
	}
	const elements = menu.map((element, index) => {
		const key = element.uuid || element.key || index;
		if (element.group) {
			const ui = element.group.map(e => {
				return l(e, e.uuid)
			})
			return (
				<SubMenu
					key={element.uuid}
					title={<span style={style}>{element.title}</span>}
					inlineIndent={0}
				>
					{ui}
				</SubMenu>

				// <Menu.ItemGroup title={
				// 	<>
				// 		{/* <Menu.Divider></Menu.Divider> */}
				// 		{element.title && <Divider type="horizontal"
				// 			orientation="left"
				// 			style={{ margin: "12px 0", fontSize: "13px", fontWeight: "600", padding: "0px 15px 0px 5px" }} >
				// 			{element.title}
				// 		</Divider>}
				// 	</>} key={key}>
				// 	{ui}
				// </Menu.ItemGroup>
			)
		} else {
			return l(element, key)
		}
	})
	const change = ({ key }) => {
		onChange(key, menu)
	}
	return (
		<>
			<Divider type="horizontal"
				orientation="left"
				style={{ margin: "12px 0", fontSize: "13px", fontWeight: "600", padding: "0px 15px 0px 5px" }} >
				Подменю
			</Divider>
			<Menu
				mode="inline"
				defaultSelectedKeys={[active]}
				selectedKeys={[active]}
				// defaultOpenKeys={['sub1']}
				style={{ border: "none" }}
				inlineIndent={10}
				onClick={change}
			>
				{elements}
			</Menu>
		</>
	)
}
function MenuLevelThree({ active, menu, onChange }) {
	if (menu.length <= 0) return (<></>);
	const style = {
		marginBottom: "0px",
		marginTop: "0px",
		fontSize: "13px",
		paddingRight: "10px"
	}
	const l = (element, key) => {
		const count = (element.badge) ? element.badge(element).count : 0;
		const icon = (element.icon) ? element.icon(element) : <></>;
		return (
			<Menu.Item style={style} key={key}>
				<Tooltip title={element.name} mouseEnterDelay={0.8}>
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
							{icon}{element.name}
						</div>
						<div style={{ width: "37px", textAlign: "right" }}>
							{/* {count > 0 && <Badge color="#ff4d4f" />} */}
							<Badge count={count} overflowCount={99} />
						</div>
					</div>
				</Tooltip>
			</Menu.Item>
		)
	}
	const elements = menu.map((element, index) => {
		const key = element.uuid || element.key || index;
		if (element.group) {
			const ui = element.group.map(e => {
				return l(e, e.uuid)
			})
			return (
				<SubMenu
					key={element.uuid}
					title={<span style={style}>{element.title}</span>}
					inlineIndent={0}
				>
					{ui}
				</SubMenu>

				// <Menu.ItemGroup title={
				// 	<>
				// 		{/* <Menu.Divider></Menu.Divider> */}
				// 		{element.title && <Divider type="horizontal"
				// 			orientation="left"
				// 			style={{ margin: "12px 0", fontSize: "13px", fontWeight: "600", padding: "0px 15px 0px 5px" }} >
				// 			{element.title}
				// 		</Divider>}
				// 	</>} key={key}>
				// 	{ui}
				// </Menu.ItemGroup>
			)
		} else {
			return l(element, key)
		}
	})
	const change = ({ key }) => {
		onChange(key, menu)
	}
	return (
		<>
			<Divider type="horizontal"
				orientation="left"
				style={{ margin: "12px 0", fontSize: "13px", fontWeight: "600", padding: "0px 15px 0px 5px" }} >
				Закладки
			</Divider>
			<Menu
				mode="inline"
				defaultSelectedKeys={[active]}
				selectedKeys={[active]}
				// defaultOpenKeys={['sub1']}
				style={{ border: "none" }}
				inlineIndent={10}
				onClick={change}
			>
				{elements}
			</Menu>
		</>
	)
}

function Home(props) {
	let navigate = useNavigate();
	let location = useLocation();
	const auth = useAuth();
	const dispatch = useDispatch();
	const user = useSelector(state => state.home.user);
	const meta = useSelector(state => state.meta);

	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();

	const [userConfig, _setUserConfig] = useState({});
	const [translates, setTranslates] = useState();

	const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })
	const t = React.useMemo(() => _.bind(translate, {
		translate: translates,
		config: language
	}), [translates, language]);
	// const t = useTranslateContext();
	// console.log(t("да"));

	const setUserConfig = (name, value, onChange) => {
		POST(auth, "/api/setuserconfig", {
			key: name,
			value: value
		}, ({ data }) => {
			var arr = [data];
			var obj = Object.fromEntries(arr.map(i => {
				return [
					i.key,
					i.value
				]
			}));
			let i = { ...userConfig, ...obj };
			// let o = REDUX_UserConfig.actions.setObject(i);
			// dispatch(o);
			_setUserConfig(i)
			if (onChange) {
				onChange(i);
			}
		}, errorCatch);
	};

	useEffect(
		() => {
			auth.fetch('/api/meta').then(res => {
				if (res && res.data && dispatch) {
					dispatch({ type: 'META', payload: res.data })
				}
			});
			auth.fetch('/api/iam').then(res => {
				if (res && res.data) {
					dispatch({ type: 'USER', payload: res.data })
				}
			});
		},
		[auth, dispatch]
	);

	useEffect(() => {
		READWITH(auth, 'Translate', [
			QueryDetail("model")
		], ({ data }) => {
			if (data.length > 0) {
				let o = Object.fromEntries(data.map(i => {
					return [
						i.key,
						{
							ru: i.ru,
							en: i.en,
							es: i.es,
							tr: i.tr,
						},
					]
				}));
				// dispatch(REDUX_Translate.actions.setObject(o));
				setTranslates(o)
			}
		}, errorCatch)
		READWITH(auth, 'UserConfig', [
			QueryDetail("model")
		], ({ data }) => {
			if (data.length > 0) {
				var obj = Object.fromEntries(data.map(i => {
					return [
						i.key,
						i.value
					]
				}));
				// dispatch(REDUX_UserConfig.actions.setObject(obj));
				_setUserConfig(obj);
			}
		}, errorCatch)
	}, [auth]);

	const logout = () => {
		auth.logout(() => {
			navigate('/');
		});
	}
	const logoutall = (e) => {
		e.stopPropagation();
		e.preventDefault();
		confirm({
			title: t('Вы действительно хотите выйти на всех устройствах?'),
			icon: <Icofont icon="logout" style={{ color: "red" }} />,
			content: <span style={{ fontSize: "12px" }}>{t("На всех подключенных устройствах будет отменена текущая сессия аутентификации и потребуется повторно ввести логин и пароль для породолжения работы")}</span>,
			okText: t('Выйти'),
			cancelText: t('Отмена'),
			onOk() {
				auth.logoutall(() => {
					navigate('/');
				});
			},
			onCancel() {
			},
		})
	}
	const menu = () => {
		let menu = [];
		menu.push({
			key: 'web',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><i className="fa fa-globe" style={{ paddingRight: "4px", color: "blue" }}></i> {t("Главный сайт")}</div>
			</a>),
		});
		menu.push({
			key: 'lk',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><Icofont icon="home" style={{ paddingRight: "8px", color: "orange" }} />{t("Личный кабинет")}</div>
			</a>),
		});
		menu.push({
			key: 'jack',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><Icofont icon="ui-calendar" style={{ paddingRight: "8px", color: "green" }} /> {t("Войти в мероприятие")}</div>
			</a>),
		});
		if (HasRole(user, "root") || HasRole(user, "admin")) {
			menu.push({
				type: 'divider',
			});
			menu.push({
				key: 'admin',
				label: (<NavLink to="admin">
					{({ isActive }) =>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<div><Icofont icon="settings" style={{ paddingRight: "8px", color: (isActive) ? "#1890ff" : "black" }} />{t("Администрирование")}</div>
							<div style={{ flex: 0 }} onClick={() => { }}></div>
						</div>
					}
				</NavLink>),
			});
		}
		if (HasRole(user, "root")) {
			menu.push({
				type: 'divider',
			});
			menu.push({
				key: 'root',
				label: (<NavLink to="root">
					{({ isActive }) =>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<div><Icofont icon="gear" style={{ paddingRight: "8px", color: (isActive) ? "#1890ff" : "black" }} />Конфигурация</div>
							<div style={{ flex: 0 }} onClick={() => { }}></div>
						</div>
					}
				</NavLink>),
			});
		}
		// menu.push({
		// 	key: 'profile',
		// 	label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://auth.${auth.getDomainWithoutSubdomain(window.location.href)}/common/profile`} style={{ display: "flex", justifyContent: "space-between" }}>
		// 		<div><Icofont icon="user" /> {t("Профиль")}</div>
		// 	</a>),
		// });
		menu.push({
			type: 'divider',
		});
		// if (isAnyFederationAdministrator(user)) {
		// 	menu.push({
		// 		key: '1',
		// 		label: (<NavLink to="settings">
		// 			{({ isActive }) =>
		// 				<div style={{ display: "flex", justifyContent: "space-between" }}>
		// 					<div><Icofont icon="settings" style={{ paddingRight: "8px", color: (isActive) ? "#1890ff" : "black" }} />Настройки</div>
		// 					<div style={{ flex: 0 }} onClick={() => { }}></div>
		// 				</div>
		// 			}
		// 		</NavLink>),
		// 	});
		// }
		menu.push({
			key: 'logout',
			label: (
				<div style={{ display: "flex", justifyContent: "space-between" }} onClick={logout}>
					<div><LogoutOutlined /> {t("Выход")}</div>
					<div style={{ flex: 0, color: "red" }} onClick={logoutall}>
						<Tooltip title={t("Выйти на всех устройствах")}>
							<Icofont icon="logout" />
						</Tooltip>
					</div>
				</div>
			),
		});
		return menu;
	}

	return (
		<TranslatesContext.Provider value={translates}>
			<TranslateContext.Provider value={t}>
				<MetaContext.Provider value={meta}>
					<UserContext.Provider value={user}>
						<UserConfigContext.Provider value={[userConfig, setUserConfig]}>
							<LanguageContext.Provider value={[language, setLanguage]}>
								<LangSwitchContext.Provider value={<LangSwitch userConfig={userConfig} />}>
									<Layout>
										<FedHeader user={user} logout={logout} logoutall={logoutall} layout={"web"}>
											<Menu items={menu()} />
										</FedHeader>
										{/* <Header className="header" style={{ backgroundColor: "white" }}>
							<div style={{ width: "1000px", margin: "0 auto" }}>
								<div style={{ float: "left" }}>
									<a href={auth.schemhttp + "://" + auth.getDomainWithoutSubdomain(window.location.href)} className="logo"></a>
								</div>
								<div style={{ float: "right" }}>
									<Dropdown overlay={
										<div style={{ color: "white", borderRadius: "4px" }}>
											<Menu items={menu()} />
										</div>}>
										<div style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
											<div style={{ lineHeight: "20px", textAlign: "right", paddingRight: "15px" }}>
												<div style={{ fontWeight: "600", fontSize: "14px" }}>{user.lastname} {user.firstname}</div>
												<div style={{ fontSize: "12px" }}>{user.email}</div>
											</div>
											<div>
												<Avatar src={(user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user?.avatarMin : undefined} size="large" shape='square' icon={<UserOutlined style={{ padding: 0 }} />} />
											</div>
										</div>
									</Dropdown>
								</div>
							</div>
						</Header> */}
										<Content style={{ padding: '25px 25px 0 25px' }}>
											<Layout style={{ width: layoutWidth, margin: "0 auto" }}>
												<Content style={{ minHeight: 600, padding: "0px 0px 0px 12px" }}>
													<Routes>
														<Route index element={<CommonProfile {...props} />} />
														<Route exact path="/common/profile" element={<CommonProfile {...props} />} />
														{(HasRole(user, "root") || HasRole(user, "admin")) && <Route exact path="/admin" element={<Admin {...props} />} />}
														{(HasRole(user, "root")) && <Route exact path="/root" element={<ConfigPage {...props} />} />}
													</Routes>
												</Content>
											</Layout>
										</Content>
										<Footer style={{ textAlign: 'center' }}>
											<div>{t("Общероссийская физкультурно-спортивная общественная организация \"Всероссийская федерация социальных танцев\"")}</div>
										</Footer>
									</Layout>
								</LangSwitchContext.Provider>
							</LanguageContext.Provider>
						</UserConfigContext.Provider>
					</UserContext.Provider>
				</MetaContext.Provider>
			</TranslateContext.Provider>
		</TranslatesContext.Provider>
	);
};

export default Home;